{
  "version": 1,
  "asset_id": "6a02acaf-d313-4e0c-964a-6112c96dcb2d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/6a02acaf-d313-4e0c-964a-6112c96dcb2d/austin-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/6a02acaf-d313-4e0c-964a-6112c96dcb2d/austin-1280.avif",
  "original_filename": "austin-1280.avif",
  "size": 62759,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:25:45Z"
}
